import React from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router';
import { signinWithGoogle, signinWithFacebook } from '../../utils/firebase';
import { loginUser } from '../../_actions/userActions';
import { GooglePlusCircleFilled, FacebookFilled } from '@ant-design/icons';
import { Button } from 'antd';

function LoginPage(props) {
  const dispatch = useDispatch();

  const googleSigninHandler = () => {
    signinWithGoogle()
      .then((result) => {
        const user = result.user;
        const loginData = {
          u_id: user.uid,
          isLogin: true,
        };
        dispatch(loginUser(loginData));
        localStorage.setItem('u_id', user.uid);
        alert(`${user.displayName}님 환영합니다.`);
        props.history.push('/');
      })
      .catch((error) => {
        alert(`${error.email} 사용 불가 ${error.message}`);
        props.history.push('/');
      });
  };

  const facebookSigninHandler = () => {
    signinWithFacebook()
      .then((result) => {
        const user = result.user;
        const loginData = {
          u_id: user.uid,
          isLogin: true,
        };
        dispatch(loginUser(loginData));
        localStorage.setItem('u_id', user.uid);
        alert(`${user.displayName}님 환영합니다.`);
        props.history.push('/');
      })
      .catch((error) => {
        alert(`${error.email} 사용 불가 ${error.message}`);
        props.history.push('/');
      });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '700px',
      }}
    >
      <h2>로그인 방법을 선택하세요</h2>
      <br />
      <br />
      <Button
        icon={<GooglePlusCircleFilled />}
        onClick={googleSigninHandler}
        size='large'
        style={{ width: 400, height: 50, fontSize: '1.25rem' }}
      >
        Google
      </Button>
      <br />
      <br />
      <Button
        icon={<FacebookFilled />}
        onClick={facebookSigninHandler}
        size='large'
        style={{ width: 400, height: 50, fontSize: '1.25rem' }}
      >
        Facebook
      </Button>
    </div>
  );
}

export default withRouter(LoginPage);
